import DrumBox from "./components/DrumBox";

function App() {
  return(
    <div>
      <DrumBox />
    </div>
  ) ;
}

export default App;
